
// This is LandingToolsNav.js
import React from 'react';
import { NavLink } from 'react-router-dom';
import { FaChartLine, FaRegStar, FaChartBar, FaSearch } from 'react-icons/fa';
import './LandingToolsNav.css';

export default function LandingToolsNav() {
  const navClass = ({ isActive }) =>
    isActive ? 'landing-nav-item landing-nav-item--active' : 'landing-nav-item';

  return (
    <nav className="landing-nav" aria-label="StockVisualize tools">
      <NavLink to="/visualization" className={navClass}>
        <FaChartBar className="landing-nav-icon" />
        <span className="landing-nav-text">
          <span className="landing-nav-title">Stock Visualization</span>
          <span className="landing-nav-subtitle">Visualise a single stock</span>
        </span>
      </NavLink>

      <NavLink to="/ratio-visualization" className={navClass}>
        <FaChartBar className="landing-nav-icon" />
        <span className="landing-nav-text">
          <span className="landing-nav-title">Stock Ratio Visualization</span>
          <span className="landing-nav-subtitle">Track fundamentals over time</span>
        </span>
      </NavLink>

      <NavLink to="/comparison" className={navClass}>
        <FaChartLine className="landing-nav-icon" />
        <span className="landing-nav-text">
          <span className="landing-nav-title">Stock Comparison</span>
          <span className="landing-nav-subtitle">Compare companies</span>
        </span>
      </NavLink>

      <NavLink to="/watchlist" className={navClass}>
        <FaRegStar className="landing-nav-icon" />
        <span className="landing-nav-text">
          <span className="landing-nav-title">Watchlist</span>
          <span className="landing-nav-subtitle">Monitor ideas</span>
        </span>
      </NavLink>

      <NavLink to="/screener" className={navClass}>
        <FaSearch className="landing-nav-icon" />
        <span className="landing-nav-text">
          <span className="landing-nav-title">Screen</span>
          <span className="landing-nav-subtitle">Filter stocks</span>
        </span>
      </NavLink>
    </nav>
  );
}
